import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Twitter } from 'lucide-react';
import lg from './logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-300 py-14 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          
          {/* Logo ve Açıklama */}
          <div>
            <Link to="/" className="flex items-center space-x-3 mb-4 group">
              <img src={lg} alt="Mekânname Logo" className="w-12 h-12 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="text-3xl font-extrabold text-amber-400 group-hover:text-amber-300 transition duration-300">
                Mekânname
              </h3>
            </Link>
            <p className="text-gray-400 text-m leading-relaxed">
              Geçmişin kapılarını aralayan, tarihi ve kültürel rotaları keşfetmenizi sağlayan uygulamanız.
            </p>
          </div>

          {/* Keşfet */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4 border-b border-indigo-500 pb-2 transition duration-300">
              Keşfet
            </h4>
            <ul className="space-y-2 text-m">
              <li><Link to="/" className="hover:text-indigo-400">Anasayfa</Link></li>
              <li><Link to="/upload" className="hover:text-indigo-400">Hemen Başla</Link></li>
              <li><Link to="/route" className="hover:text-indigo-400">Tüm Rotalar</Link></li>
              <li><Link to="/about" className="hover:text-indigo-400">Hakkımızda</Link></li>
            </ul>
          </div>

          {/* Destek */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4 border-b border-teal-500 pb-2 transition duration-300">
              Yardım & Destek
            </h4>
            <ul className="space-y-2 text-m">
              <li><Link to="/contact" className="hover:text-teal-400">İletişim</Link></li>
              <li><Link to="/sss" className="hover:text-teal-400">S.S.S</Link></li>
              <li><Link to="/privacy" className="hover:text-teal-400">Gizlilik</Link></li>
              <li><Link to="/service" className="hover:text-teal-400">Kullanım Koşulları</Link></li>
            </ul>
          </div>

          {/* Sosyal Medya */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4 border-b border-amber-500 pb-2 transition duration-300">
              Bizi Takip Et
            </h4>
            <div className="flex space-x-5 mt-2">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Alt Bilgi */}
        <div className="text-center text-sm text-gray-500 mt-12 pt-8 border-t border-gray-800">
          &copy; {new Date().getFullYear()} Mekânname. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
